<template>
    <div class="w3-container">
        <edit-token ref="edit-token" @inserted="finishInsertToken($event)" @updated="finishUpdateToken($event)"
                @deleted="finishDeleteToken($event)" @force-reload="loadTokens()" />
        <p>{{ $t('This function allows you to manage API tokens.') }}</p>
        
        <p>
            <button class="twi-button w3-button w3-small" @click="beginCreateToken()">{{ $t('Create new token') }}</button>
        </p>
        <div class="twi-table">
            <div class="twi-table-header w3-cell-row">
                <div class="w3-cell" style="width: 25%;">
                    <a href="javascript:void(0)" @click="setSortField('token')">{{ $t('Token') }}</a>
                    <img v-show="sortField === 'token' && sortOrder === 'ASC'" src="@/assets/img/sort-asc-white-16.png" alt="ASC">
                    <img v-show="sortField === 'token' && sortOrder === 'DESC'" src="@/assets/img/sort-desc-white-16.png" alt="ASC">
                </div>
                <div class="w3-cell" style="width: 25%;">
                    <a href="javascript:void(0)" @click="setSortField('created')">{{ $t('Created') }}</a>
                    <img v-show="sortField === 'created' && sortOrder === 'ASC'" src="@/assets/img/sort-asc-white-16.png" alt="ASC">
                    <img v-show="sortField === 'created' && sortOrder === 'DESC'" src="@/assets/img/sort-desc-white-16.png" alt="ASC">
                </div>
                <div class="w3-cell" style="width: 25%;">{{ $t('Domains') }}</div>
                <div class="w3-cell" style="width: 25%;">{{ $t('Note') }}</div>
            </div>
            <div v-for="token in tokens" :key="token.token" class="twi-table-row w3-cell-row"
                    @click="beginEditToken(token)">
                <div class="w3-cell" style="width: 25%;">{{ token.token }}</div>
                <div class="w3-cell" style="width: 25%;">{{ token.created | datetime_format }}</div>
                <div class="w3-cell" style="width: 25%;">
                    <span v-for="d in token.domains" :key="d.domain">{{ d.domain }}<br></span>
                </div>
                <div class="w3-cell" style="width: 25%;">{{ token.note }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from 'Api'

import '@/utils/DateTime'

import Token from '@/model/Token'

import EditToken from '@/components/EditToken'

export default {
    name: 'Tokens',

    components: {
        EditToken
    },

    data () {
        return {
            tokens: [],
            sortField: 'created',
            sortOrder: 'DESC'
        }
    },

    mounted () {
        this.loadTokens()
    },

    methods: {
        loadTokens () {
            let self = this

            Api.getTokens()
                .then(resp => {
                    if (typeof resp.data !== 'object') {
                        window.toast({
                            text: self.$i18n.t('Loading tokens has failed.'),
                            color: 'red'
                        })
                        return
                    }

                    try {
                        self.tokens = resp.data.map(it => Token.fromObject(it))
                        self.sortTokens()
                    } catch (err) {
                        window.toast({
                            text: self.$i18n.t('Invalid API response.'),
                            color: 'red'
                        })
                        console.error(err)
                    }
                })
                .catch(err => {
                    let resp = err.response
                    if (resp.status === 403) {
                        window.toast({
                            text: self.$i18n.t('You are not authorised to access the tokens.'),
                            color: 'red'
                        })
                    } else {
                        window.toast({
                            text: self.$i18n.t('Loading tokens has failed.'),
                            color: 'red'
                        })
                    }
                })
        },

        setSortField (field) {
            if (this.sortField === field) {
                this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
            } else {
                this.sortField = field
                this.sortOrder = 'ASC'
            }
            this.sortTokens()
        },

        sortTokens () {
            let field = this.sortField
            let order = this.sortOrder

            this.tokens.sort((a, b) => {
                if (typeof a[field] === 'undefined' || typeof b[field] === 'undefined' || a[field] === b[field]) {
                    return 0
                }

                let altbres = a[field] < b[field] ? -1 : 1
                return order === 'ASC' ? altbres : -altbres
            })
        },

        beginCreateToken () {
            this.$refs['edit-token'].showCreate()
        },

        beginEditToken (token) {
            if (typeof token === 'object') {
                this.$refs['edit-token'].showEdit(token)
            }
        },

        finishInsertToken (event) {
            if (typeof event.token !== 'object') {
                return
            }

            this.tokens.push(event.token)
            this.sortTokens()
        },

        finishUpdateToken (event) {
            if (typeof event.token !== 'object') {
                return
            }

            this.tokens = this.tokens.filter(it => it.token !== event.token.token)
            this.tokens.push(event.token)
            this.sortTokens()
        },

        finishDeleteToken (event) {
            if (typeof event.token !== 'object') {
                return
            }

            this.tokens = this.tokens.filter(it => it.token !== event.token.token)
            this.sortTokens()
        }
    }
}
</script>

<i18n src="@/lang/common.json"></i18n>
<i18n src="@/lang/tokens.json"></i18n>
